'use client'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { markBadgeCelebrated } from '@/lib/badges/badge-actions'

export function useMarkCelebrated() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (userBadgeId: string) =>
      markBadgeCelebrated({ userBadgeId }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['uncelebrated-badges'] })
    },
  })
}
